module.exports = __webpack_public_path__ + "img/AA.9478c32d.jpg";